var render = function render(){var _vm=this,_c=_vm._self._c;return _c('anim-text',{staticClass:"b-content-text",attrs:{"text":_vm.data.body,"cms":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }